/**
 * @typedef {number | {scenario_id?: number|string, scenarioId?: number|string, id?: number|string, key?: number|string}} ScenarioLike
 */

/**
 * @param {ScenarioLike} n
 * @returns {number|undefined}
 */
export const getScenarioId = (n) => {
  if (typeof n === 'number' && Number.isInteger(n)) return n;
  if (n == null || typeof n !== 'object') return undefined;

  const raw = n.scenario_id ?? n.scenarioId ?? n.id ?? n.key;
  const num = typeof raw === 'string' ? Number(raw) : raw;
  return Number.isInteger(num) ? num : undefined;
};